import axios from "axios"
import { ITyCRequest } from "../../../interfaces/ITyCRequest";

export const obtenerTyC = async (postData: ITyCRequest) => {
    return axios.post('api/TerminosCondiciones/ObtenerTyC',postData)
}

/*import { ERROR_ACEPTAR_TyC, ERROR_OBTENER_TyC, FAILED_ACEPTAR_TyC, FAILED_OBTENER_TyC, SUCCESS_ACEPTAR_TyC, SUCCESS_OBTENER_TyC } from "../utilities/constants";

export const obtenerTyC = async (postData: ITyCRequest) => {
    try {
        
        const response = await fetch('api/TerminosCondiciones/ObtenerTyC', {
            method: 'POST',
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(postData)
        })
    
        if (response.status === 200) {
            let result = await response.json();
            return {data:result, message:SUCCESS_OBTENER_TyC};
        }else{
            return {data:[], message:FAILED_OBTENER_TyC};
        }
        
    } catch (error) {
        return {data:[], message:ERROR_OBTENER_TyC, error:error};
    }
}*/


